import React, { FC } from "react";
import iconCheck from "shared/icons/chat/iconCheck.svg";
import pinIcon from "../../../shared/icons/chat/pin.svg";

interface IChatMessage {
  title?: string;
  label?: string;
  message: string;
  time: string;
  isYoursMessage: boolean;
  delivered: boolean;
  icon?: string;
  isPinned?: boolean;
  profession?: string;
  replyMessage?: {
    text: string;
    sender: string;
    id: string;
    profession?: string;
  };
  onReplyClick?: (id: string) => void;
}

const ChatMessage: FC<IChatMessage> = ({
  title,
  label,
  message,
  time,
  icon,
  isYoursMessage,
  delivered,
  isPinned,
  profession,
  replyMessage,
  onReplyClick,
}) => {
  return (
    <div
      className="flex flex-row items-start w-[386px] gap-[8px] pb-[4px]"
      style={{
        paddingRight: isYoursMessage ? "0px" : "16px",
        paddingLeft: isYoursMessage ? "16px" : "0px",
        justifyContent: isYoursMessage ? "flex-end" : "flex-start",
      }}
    >
      {!isYoursMessage && (
        <div className="w-[40px] flex-shrink-0">
          {icon && (
            <img
              className="w-[40px] h-[40px] rounded-full"
              src={icon}
              alt="icon"
            />
          )}
        </div>
      )}
      <div className="flex flex-col">
        <div
          className={`max-w-[322px] p-[12px] flex flex-col gap-[8px] bg-blue-100 rounded-[8px] ${
            isPinned ? "border-l-2 border-[#0767FD]" : ""
          }`}
        >
          <div className="flex flex-row justify-between items-center flex-wrap">
            {title && (
              <div className="flex items-center flex-wrap gap-2">
                <div className="text-sm text-[#0767FD] font-[500]">{title}</div>
                {profession && profession.trim() !== "" && (
                  <div className="px-2 py-0.5 bg-[#E6EFFF] text-[#0767FD] text-xs rounded-full">
                    {profession}
                  </div>
                )}
              </div>
            )}
            {isPinned && (
              <div className="ml-auto">
                <img src={pinIcon} alt="pinned" className="w-3 h-3" />
              </div>
            )}
          </div>

          {/* Отображение сообщения-ответа */}
          {replyMessage && (
            <div
              className="bg-blue-50 p-2 rounded mb-1 cursor-pointer border-l-2 border-[#0767FD]"
              onClick={() => onReplyClick && onReplyClick(replyMessage.id)}
            >
              <div className="flex items-start">
                <div className="flex-1">
                  <div className="flex items-center">
                    <div className="text-xs text-blue-500 font-medium">
                      {replyMessage.sender}
                    </div>
                    {replyMessage.profession && (
                      <div className="ml-2 px-1 py-0 text-[10px] text-[#0767FD]">
                        {replyMessage.profession}
                      </div>
                    )}
                  </div>
                  <div className="text-xs text-gray-600 truncate max-w-[250px]">
                    {replyMessage.text}
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="text-sm">{message}</div>
          <div className="flex justify-end items-center gap-[4px]">
            <div className="flex text-xs text-[#A4AFC2]">{time}</div>
            {delivered && (
              <div>
                <img src={iconCheck} alt="check" />
              </div>
            )}
          </div>
        </div>
      </div>
      {isYoursMessage && (
        <div className="w-[40px] flex-shrink-0">
          {/* Empty div to maintain alignment */}
        </div>
      )}
    </div>
  );
};

export { ChatMessage };
